import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { PeoplePicker } from "@microsoft/mgt-react";

const GroupDialog = ({ isOpen, onClose, handleGroupAdd }) => {
  const [emails, setEmails] = useState([]);
  const [groupName, setGroupName] = useState("");

  const handleSelectionChange = (e) => {
    const selectedEmails = e.detail?.map((item) => item.userPrincipalName) || [];
    setEmails(selectedEmails);
  };

  const handleGroupNameChange = (e) => {
    setGroupName(e.target.value);
  };

  const isSubmitDisabled = !groupName.trim() || emails.length === 0;

  const Submit = () => {
    handleGroupAdd({ GroupName: groupName, userId: emails });
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} fullWidth maxWidth="sm">
      <DialogContent>
        {/* Header */}
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography variant="h6" fontWeight={500}>
            Add New Group
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Box mt={2}>
          <Typography>Group Name</Typography>
          <TextField
            fullWidth
            value={groupName}
            onChange={handleGroupNameChange}
            variant="outlined"
          />

          <Box mt={2}>
            <PeoplePicker
              selectionChanged={handleSelectionChange}
              sx={{ minHeight: "50px", width: "100%" }}
              placeholder={emails.length > 0 ? "" : "Enter Name or Email Addresses"}
            />
          </Box>
        </Box>
      </DialogContent>

      {/* Actions */}
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button
          disabled={isSubmitDisabled}
          onClick={Submit}
          sx={{
            padding: "10px",
            backgroundColor: isSubmitDisabled ? "lightGray" : " #212129",
            color: "white",
            borderRadius: "20px",
            "&:hover": {
              backgroundColor: isSubmitDisabled ? "lightGray" : "darkgray",
            },
          }}
        >
          Add
        </Button>

        <Button
          onClick={onClose}
          variant="outlined"
          sx={{
            padding: "10px",
            border: "1px solid  #212129",
            color: " #212129",
            backgroundColor: "white",
            borderRadius: "20px",
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GroupDialog;
